import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { UpdateMemberBadgesRequest, ViewmemberBadgesRequest } from './member-badge.types';

import { requestModifyMemberBadges, requestViewMemberBadges } from './member-badge.actions';

export const useMemberBadgeApi = () => {
  const dispatch = useDispatch();

  const viewMemberBadges = useCallback(
    (requestData: ViewmemberBadgesRequest, onSuccess?: () => void) => {
      dispatch(requestViewMemberBadges({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const modifyMemberBadges = useCallback(
    (requestData: UpdateMemberBadgesRequest, onSuccess?: () => void) => {
      dispatch(requestModifyMemberBadges({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { viewMemberBadges, modifyMemberBadges };
};
